import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import VueApollo from 'vue-apollo'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { getApolloLink } from './getNetworkInterface'

Vue.use(VueApollo)

const apolloClient = new ApolloClient({
  link: getApolloLink(),
  cache: new InMemoryCache(),
  connectToDevTools: true,
  queryDeduplication: true,
})

const apolloProvider = new VueApollo({
  clients: {
    a: apolloClient,
  },
  defaultClient: apolloClient,
})

export default apolloProvider
